exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/core-js/library/modules/_wks-ext.js
// module id = 200
// module chunks = 0